export enum APP_MODE {
  BOOKING = 'BOOKING', // for booking app
  ADMIN = 'ADMIN', // for admin app
  CHECKOUT = 'CHECKOUT', // for checkout app
  CHECKIN = 'CHECKIN', // for checkin app
  STAFF = 'STAFF', // for staff app
}
